// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"_8d082d5","hover":"_a7d9de4","cardContentContainer":"_1df469b","icon":"_52db452","title":"_d123a79","textContent":"_d496527","button":"_11d31d7","image":"_81c8031"};